import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles({
    errorPageBody: {
        width: "1366px",
        maxWidth: "100%",
        height: "89vh",
        maxHeight: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        background: "#F8F8F8 0% 0% no-repeat padding-box",
        opacity: 1,
    },
    errorLabel1: {
        textAlign: "left",
        font: "normal normal 600 20px/16px Open Sans",
        letterSpacing: "0px",
        color: "#000000D9",
        opacity: 1,
        margin: "4px",
    },
    errorLabel2: {
        textAlign: "left",
        font: "normal normal 600 16px/16px Open Sans",
        letterSpacing: "0px",
        color: "##707070",
        opacity: 1,
        margin: "4px",
    }
});

export default function ErrorPage(props) {
  
    const classes = useStyles();
    const {open, onClose} = props;
    const { t } = useTranslation(['styles', 'translation']);
    
    return (
        <div className={classes.errorPageBody} >
            <img src={require("../../../Icons/AutheticationError.svg").default} style={{width:"350px", height:"180px"}} alt='AutheticationError Icon'/>
            <div className={classes.errorLabel1} >
                {t(`translation:${"An error has occurred"}`)}  
            </div>
            <div className={classes.errorLabel2}>
                {t(`translation:${"Invalid Authentication."}`)} 
            </div>
        </div>
    );
}
